const t=o=>/^#[0-9a-f]{3}(?:[0-9a-f]{3})?$/i.test(o);export{t as isHexColor};
//# sourceMappingURL=colorUtils.js.map
